module.exports = __webpack_public_path__ + "assets/img/tit3.1dd71b94.png";